import { CheckPermissionsModes } from "@elit-hair/elit-tools";
import { TbChartBar, TbFileDescription, TbReportAnalytics, TbTable, TbTelescope } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import { REPORTS_PAGE_PERMISSIONS } from "@/pages/performance/reports/utils/report-access";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const performanceRoutes: NavigationRoute[] = [
    {
        to: APP_ROUTES_TO.PERFORMANCE,
        meta: {
            label: "performance",
            order: 3,
            icon: TbChartBar,
            visibleInSidebar: true,
        },
        children: [
            {
                to: APP_ROUTES_TO.PERFORMANCE_KPIS,
                meta: {
                    label: "kpis",
                    order: 1,
                    icon: TbReportAnalytics,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_KPIS_READ],
                },
            },
            {
                to: APP_ROUTES_TO.PERFORMANCE_QUALITY_WATCH,
                meta: {
                    label: "quality_watch",
                    order: 5,
                    icon: TbTelescope,
                    visibleInSidebar: false,
                    permissions: [PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE],
                },
            },
            {
                to: APP_ROUTES_TO.PERFORMANCE_AGENT_QUALITY_MATRIX,
                meta: {
                    label: "agent_quality_matrix",
                    order: 6,
                    icon: TbTable,
                    visibleInSidebar: false,
                    permissions: [PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE, PERMISSIONS.CALL_SVC_ADMIN_BASE],
                    permissionMode: CheckPermissionsModes.ANY,
                },
            },
            {
                to: APP_ROUTES_TO.PERFORMANCE_REPORTS,
                meta: {
                    label: "reports",
                    order: 2,
                    icon: TbFileDescription,
                    visibleInSidebar: true,
                    permissions: REPORTS_PAGE_PERMISSIONS,
                    permissionMode: CheckPermissionsModes.ANY,
                },
            },
        ],
    },
];
